<template>
  <v-toolbar flat dense color="bkground">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="registrarConvenio">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ConveniosToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    registrarConvenio() {
      this.$emit('registrarConvenio');
    },
  },
};
</script>

<style lang="scss">

</style>
